import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { ProcessRouteHeader } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProcessRouteHeaderService extends TmsWebBaseEditService<ProcessRouteHeader, ProcessRouteHeader> {
  constructor() {
    super('ProcessRouteHeader', $localize`Process Route`);
  }
}
